export default __webpack_public_path__ + "static/media/52_mobile.a17644d8.jpg";